// src/Payroll_Management/PayRoll_Report/EmployeeResignationAllReportPrint.jsx
import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const BASE_URL = "https://nissi-india.com";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

const EmployeeResignationAllReportPrint = () => {
  const q = useQuery();

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState("");

  const finYearId = q.get("finYearId") || "";
  const loginBranchId = q.get("loginBranchId") || "";

  const branchId = q.get("branchId") || "Select";
  const deptId = q.get("deptId") || "Select";
  const desigId = q.get("desigId") || "Select";
  const gradeId = q.get("gradeId") || "Select";
  const empCode = q.get("empCode") || "";
  const empName = q.get("empName") || "";
  const payMode = q.get("payMode") || "Select";
  const pfNonPf = q.get("pfNonPf") || "Select";
  const fromDate = q.get("fromDate") || "";
  const toDate = q.get("toDate") || "";
  const resignDate = q.get("resignDate") || "";

  const company = {
    name: "Nissi Infotech",
    sub1: "CIVIL CONSTRUCTION",
    addr1: "3/42-12, Nagappa colony, Kavundampalayam, Coimbatore - 641030, Tamil Nadu.",
    addr2: "Phone No : 9003744644",
    addr3: "infraconssoft-implementations",
    logo: "/assets/company-logo.png",
  };

  useEffect(() => {
    async function load() {
      try {
        setLoading(true);
        setErr("");

        const res = await axios.get(`${BASE_URL}/api/employee-resignation-report/search`, {
          params: {
            finYearId: Number(finYearId),
            loginBranchId: Number(loginBranchId),

            branchId,
            siteId: branchId,
            empCode: String(empCode).trim(),
            empName: String(empName).trim(),
            deptId,
            desigId,
            gradeId,
            pfNonPf,
            payMode,
            fromDate: String(fromDate).trim(),
            toDate: String(toDate).trim(),
            resignDate: String(resignDate).trim(),

            export: 1,
          },
        });

        if (!res?.data?.success) {
          setErr(res?.data?.message || "Failed to load print data");
          setRows([]);
          return;
        }

        setRows(res.data.rows || []);
      } catch (e) {
        setErr(e?.response?.data?.message || e.message || "Failed to load print data");
      } finally {
        setLoading(false);
      }
    }

    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!loading && !err) {
      const t = setTimeout(() => window.print(), 300);
      return () => clearTimeout(t);
    }
  }, [loading, err]);

  const printedOn = new Date().toLocaleString();

  return (
    <div className="print-root">
      <style>{`
        /* ✅ Landscape print so columns won't cut */
        @page { size: A4 landscape; margin: 10mm; }

        * { box-sizing: border-box; }
        body { margin: 0; padding: 0; font-family: "Times New Roman", serif; color: #000; }

        .no-print { display: flex; gap: 8px; justify-content: flex-end; margin: 10px 0; }
        @media print { .no-print { display: none !important; } }

        /* ✅ Screen scroll */
        .print-root {
          min-height: 100vh;
          overflow-y: auto;
          background: #fff;
          padding: 12px;
        }

        .sheet {
          width: 100%;
          border: 1px solid #000;
          padding: 10px;
        }

        .header-box {
          border: 1px solid #000;
          padding: 10px;
        }

        .header-grid {
          display: grid;
          grid-template-columns: 120px 1fr;
          gap: 10px;
          align-items: center;
        }

        .logo-box {
          border: 1px solid #000;
          width: 120px;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }

        .logo-box img { width: 100%; height: 100%; object-fit: contain; }

        .company-title { text-align: center; font-weight: bold; font-size: 22px; margin: 0; }
        .company-sub { text-align: center; font-weight: bold; font-size: 14px; margin: 4px 0; }
        .company-addr { text-align: center; font-size: 12px; margin: 2px 0; }

        .report-title {
          margin-top: 10px;
          border-top: 1px solid #000;
          padding-top: 8px;
          text-align: center;
          font-size: 14px;
          font-weight: bold;
          letter-spacing: 0.5px;
        }

        .meta-row {
          margin-top: 8px;
          display: flex;
          justify-content: space-between;
          font-size: 12px;
          gap: 10px;
          flex-wrap: wrap;
        }

        /* ✅ Horizontal scroll on screen only */
        .table-scroll {
          width: 100%;
          overflow-x: auto;
          overflow-y: hidden;
          -webkit-overflow-scrolling: touch;
          margin-top: 10px;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 12px;
        }

        /* allow screen overflow to scroll */
        .table-scroll table { min-width: 1100px; }

        th, td {
          border: 1px solid #000;
          padding: 6px 6px;
          vertical-align: middle;
        }

        thead th {
          font-weight: bold;
          text-align: center;
          white-space: nowrap;
        }

        td.center { text-align: center; }
        td.right { text-align: right; }

        .foot-note { margin-top: 8px; font-size: 12px; }

        /* ✅ PRINT: force fit page + smaller text/padding */
        @media print {
          .print-root { overflow: visible !important; padding: 0 !important; }
          .table-scroll { overflow: visible !important; }
          .table-scroll table { min-width: 0 !important; }

          table { table-layout: fixed; width: 100% !important; font-size: 10px !important; }
          th, td { padding: 3px 3px !important; }
          thead th { white-space: normal !important; }

          /* ✅ override inline widths if any (important) */
          th { width: auto !important; }
        }
      `}</style>

      <div className="no-print">
        <button
          onClick={() => window.print()}
          style={{ padding: "8px 12px", fontWeight: "bold", border: "1px solid #000", background: "#000", color: "#fff" }}
        >
          Print
        </button>
        <button
          onClick={() => window.close()}
          style={{ padding: "8px 12px", fontWeight: "bold", border: "1px solid #000", background: "#eee", color: "#000" }}
        >
          Close
        </button>
      </div>

      <div className="sheet">
        <div className="header-box">
          <div className="header-grid">
            <div className="logo-box">
              <img
                src={company.logo}
                alt="Company Logo"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
              />
            </div>

            <div>
              <div className="company-title">{company.name}</div>
              <div className="company-sub">{company.sub1}</div>
              <div className="company-addr">{company.addr1}</div>
              <div className="company-addr">{company.addr2}</div>
              {company.addr3 ? <div className="company-addr">{company.addr3}</div> : null}
            </div>
          </div>

          <div className="report-title">EMPLOYEE RESIGNATION REPORT</div>
        </div>

        {loading ? (
          <div className="foot-note">Loading...</div>
        ) : err ? (
          <div className="foot-note" style={{ color: "red" }}>{err}</div>
        ) : rows.length === 0 ? (
          <div className="foot-note">No Records Found</div>
        ) : (
          <div className="table-scroll">
            <table>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Employee Code</th>
                  <th>Employee Name</th>
                  <th>Designation</th>
                  <th>PF No.</th>
                  <th>Qualification</th>
                  <th>DOJ</th>
                  <th>Resign Date</th>
                  <th>Modified</th>
                  <th>Gross Salary</th>
                  <th>Batta</th>
                  <th>Grand Total</th>
                  <th>Spl HRA</th>
                  <th>PF</th>
                  <th>Location</th>
                </tr>
              </thead>

              <tbody>
                {rows.map((r, idx) => (
                  <tr key={`${r.fld_Employeeid ?? idx}-${idx}`}>
                    <td className="center">{idx + 1}</td>
                    <td className="center">{r.fld_Employeecode}</td>
                    <td>{r.fld_Employee}</td>
                    <td className="center">{r.fld_designationname}</td>
                    <td className="center">{r.fld_pfno}</td>
                    <td className="center">{r.fld_qualificationname}</td>
                    <td className="center">{r.DOJ}</td>
                    <td className="center">{r.resigndate}</td>
                    <td className="center">{r.modifieddate}</td>
                    <td className="right">{r.fld_grosssalary}</td>
                    <td className="right">{r.fld_dailybata}</td>
                    <td className="right">{r.grandTot}</td>
                    <td className="right">{r.fld_SpecialHRA}</td>
                    <td className="right">{r.fld_pf}</td>
                    <td className="center">{r.fld_BranchName}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div className="foot-note">
          <b>Note:</b> This is a system generated report.
        </div>
      </div>
    </div>
  );
};

export default EmployeeResignationAllReportPrint;
